import React from 'react';
import BlogGrid from '../components/sections/BlogGrid';
import Banner4 from '../components/sections/Banner4';

const Blog = () => {
  return (
    <main className="bg-black min-h-screen">
      <div className="md:pt-32 pt-12">
        <BlogGrid />
      </div>
      <Banner4 />
    </main>
  );
};

export default Blog;
